export default {"src":"/_next/static/media/advanced-threat-detection.eb51bd42.svg","height":442,"width":388,"blurWidth":0,"blurHeight":0};